export const getProtectedRouteDecision = ({
  authLoading,
  isAuthenticated,
  user,
  requireAdmin = false,
}) => {
  if (authLoading) return 'loading';
  if (!isAuthenticated) return 'login';
  if (requireAdmin && user?.role !== 'admin') return 'user-panel';
  return 'allow';
};
